module.exports = __webpack_public_path__ + "img/characters.1a68a3af.png";